import styled from 'styled-components';

export const FollowersWrapper = styled.section`
  padding: 24px 16px;
`;
